import { withInstall } from '@tw-element/utils'

import Input from './src/input.vue'

export const TwInput = withInstall(Input)
export default TwInput

export * from './src/input'
